import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetPasswordLinkFormComponent } from '../../ui/reset-password-link-form/reset-password-link-form.component';
import { ResetPwdRequest, CommunicationType } from '../../interfaces/reset-pwd.interface';
import { ResetpasswordService } from '../../data-access/resetpassword.service';
import { Subject, takeUntil } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'equine-ui-nx-reset-password-link',
  standalone: true,
  imports: [CommonModule, ResetPasswordLinkFormComponent],
  templateUrl: './reset-password-link.component.html',
  styleUrl: './reset-password-link.component.scss',
})
export class ResetPasswordLinkComponent implements OnInit {
  unsubscribe$ = new Subject<void>();
  loading: boolean = false;
  isEmailExists: boolean = true;
  isPwdLinkSent: boolean = false;
  appName!: string;
  constructor(
    private resetpasswordService: ResetpasswordService, 
    private snackBar: MatSnackBar,
    private readonly activatedRoute: ActivatedRoute
  ) { }
  ngOnInit(): void {
    this.activatedRoute.data.pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any)=>{
      this.appName = data.appName
    })
  }

  resetPassword(data: any) {
    if (data.type == "passwordlink") {
      this.sendPasswordLink(data.formData)
    } else {
      this.checkEmailExisted(data.formData);
    }
  }

  sendPasswordLink(data: any) {
    if (this.isEmailExists) {
      const reserPwdData: ResetPwdRequest = {
        email: data.email,
        appName: this.appName
      };
      this.resetpasswordService
        .sendResetPwdLink(reserPwdData)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: () => {
            this.isPwdLinkSent = true;
            this.snackBar.open(`Success: Password reset was sent successfully. Please check your email to reset your password`, 'Dismiss', { duration: 3000, panelClass: ['success-snackbar'] });
            this.loading = false;
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
            this.snackBar.open(`Error: ${err?.error?.message}.`, 'Dismiss', { panelClass: ['error-snackbar'] });
          }
        })
    }
  }

  checkEmailExisted(data: any) {
    this.isEmailExists = true;
    this.loading = true;
    const receiver = data;
    this.resetpasswordService
      .isEmailMobileUnique(CommunicationType.EMAIL, receiver, this.appName)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (data) => {
          if (data.status) {
            this.snackBar.open(`Success: Email available`, 'Dismiss', { duration: 3000, panelClass: ['success-snackbar'] });
            this.isEmailExists = true;
          }
          this.loading = false;
        },
        error: (err: HttpErrorResponse) => {
          this.isEmailExists = false;
          this.loading = false;
          this.snackBar.open(`Error: ${err?.error?.message}.`, 'Dismiss', { duration: 3000, panelClass: ['error-snackbar'] });
        }
      })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
